import { Get, Post, Put, Delete } from '../helpers';
import { ChannelRedirect } from '@/micros/homepage/settings/settings-main/components/channel-redirects';

export function GetChannelRedirects(channel: number): Promise<ChannelRedirect[]> {
  return Get({ path: `/v3/admin/channel/redirects/${channel}` });
}

export function CreateChannelRedirect(redirect: Omit<ChannelRedirect, 'id'>): Promise<ChannelRedirect> {
  return Post({ url: '/v3/admin/channel/redirect', body: redirect });
}

export function UpdateChannelRedirect(redirect: ChannelRedirect): Promise<ChannelRedirect> {
  return Put({ url: '/v3/admin/channel/redirect', body: redirect });
}

export function DeleteChannelRedirect(redirect: ChannelRedirect) {
  return Delete({ url: '/v3/admin/channel/redirect', body: redirect });
}
